import { useGetCommonStore } from '@/store';

export const usePrefilledNdbCoupon = () => {
  const useCommonStore = useGetCommonStore();

  const isPrefilledNdbCoupon = useCommonStore.use.isPrefilledNdbCoupon();
  const coupon = useCommonStore.use.prefilledNdbCoupon();

  return { isPrefilledNdbCoupon, coupon };
};
